import Lookup from 'src/componentes/select2';

const FarolAvaliacaoRiscoLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/StatusRiscoAvaliacaoLookup"
    clearable={false}
    {...rest}
  />
);

export default FarolAvaliacaoRiscoLookup;
